import moment from 'moment';

export const conditionStatuses = new Set([0, 1, 2, 3, 4, 5, 12, 13, 14, 15, 16, 28, 33, 37, 39]);
export const endDateStatuses = new Set([0, 1, 2, 3, 4, 5, 12, 13, 14, 15, 16, 28, 33, 35]);
const date = value => value && moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : '';
export const earliestDate = (...values) => values.filter(Boolean).sort()[0] || '';

export function staffClaimPeriod(staff, policy) {
  // The policy-scoped staff-list API supplies the calculated earliest date:
  // policy inception, or inception + 10 weekdays + its holiday adjustment.
  // Previous-policy records bypass that calculation and supply archived dates.
  // Recalculating here would apply the waiting period twice.
  const start = date(staff?.start_date);
  const birthday = date(staff?.date_of_birth)
    ? moment(staff.date_of_birth).add(75, 'years').format('YYYY-MM-DD') : '';
  return { start, end: earliestDate(date(staff?.end_date), birthday) };
}

export function lastAbsenceDateError({ absenceStart, absenceEnd, selectedStaff } = {}) {
  const end = date(absenceEnd);
  if (!end) return '';
  const first = date(absenceStart);
  const inception = date(selectedStaff?.start_date || selectedStaff?.inception);
  const minimum = [first, inception].filter(Boolean).sort().pop();
  if (minimum && end < minimum) {
    const reason = minimum === first ? 'the first day of absence' : 'the staff cover start date';
    return `The last day of absence cannot be before ${reason} (${moment(minimum).format('D MMM YYYY')}).`;
  }
  return '';
}

export function validateClaim(data = {}, policy, today = moment().format('YYYY-MM-DD')) {
  const errors = {};
  const { selectedStaff, selectedCondition, absenceStart, absenceEnd } = data;
  const period = staffClaimPeriod(selectedStaff, policy);
  const future = Number(selectedCondition?.future_claims) === 1;
  if (!selectedStaff?.staff_id) errors.staff = 'Select a staff member.';
  if (!selectedCondition?.condition_id) errors.condition = 'Select a condition.';
  if (!absenceStart || !date(absenceStart)) errors.startDate = 'Enter the first full day of absence.';
  else if (period.start && absenceStart < period.start) errors.startDate = `The first day of absence cannot be before ${moment(period.start).format('D MMM YYYY')}.`;
  else if (!future && absenceStart > today) errors.startDate = 'The first day of absence cannot be in the future.';
  // The first-date upper cover limit (and two-year future limit) is a calendar restriction.
  if (absenceEnd) {
    if (!date(absenceEnd)) errors.endDate = 'Enter a valid last day of absence.';
    else if (lastAbsenceDateError(data)) errors.endDate = lastAbsenceDateError(data);
    else if (!future && absenceEnd > today) errors.endDate = 'The last day of absence cannot be in the future.';
    else if (!future && period.end && absenceEnd > period.end) errors.endDate = 'The last day of absence cannot be after staff cover ends.';
  }
  return errors;
}
